import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put, post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function CancelBooking({
  fetchBooking,
  setShowCancel,
  bookingData,
  usage,
}: any) {
  const { id } = useParams()
  const { notify, profile } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [reason, setReason] = useState('')
  const [status, setStatus] = useState(bookingData.booking_status.code)

  const isApiBooking = bookingData.channel === 'api'
  const isMasterRole =
    profile?.role === 'super admin' || profile?.role === 'customer service'

  // Cancelling an API/business shipment refunds the business ledger, which
  // only the master cancel path does correctly — so on those shipments the
  // option is offered to super admin and customer service only. Agents and
  // managers get the working statuses (collected / on-hold) and nothing else.
  const canCancel = !isApiBooking || isMasterRole

  const statuses = [
    ...(canCancel
      ? [
          {
            value: 'CCD',
            label: 'Cancelled',
          },
        ]
      : []),
    {
      value: 'DRF',
      label: 'Shipment Collected',
    },
    {
      value: 'OND',
      label: 'Shipment On-hold',
    },
  ]

  async function cancelBooking() {
    // The select opens on the booking's current code (AWD/SHC), which is not
    // one of the options — without this the fall-through below would submit
    // it as 'OND' and silently put the shipment on hold.
    if (!statuses.some((item) => item.value === status)) {
      notify('warn', 'Select a status')
      return
    }
    if (status === 'CCD' && reason.length < 5) {
      notify('warn', 'A reason is required')
      return
    }
    setCancelLoading(true)

    // Check if this is a master cancellation by super admin or customer service.
    // API/business shipments always take the business path when cancelled —
    // the regular status route refuses CCD on channel 'api' because its refund
    // block writes to the user ledger, not the business one.
    const isMasterCancellation =
      isMasterRole &&
      status === 'CCD' &&
      (isApiBooking ||
        (bookingData.booking_status.code !== 'AWD' &&
          bookingData.booking_status.code !== 'OND' &&
          bookingData.booking_status.code !== 'DRF'))

    if (isMasterCancellation) {
      // Master cancellation logic
      let endpoint = ''
      let data: any = {
        reason: reason,
      }

      if (bookingData.channel === 'api') {
        // For API bookings, cancel business booking
        endpoint = 'admin/master/cancel-business-booking'
        data.bookingId = id
        data.bizId = bookingData.userId
      } else {
        // For non-API bookings, cancel user booking
        endpoint = 'admin/master/cancel-user-booking'
        data.id = id
        data.status = {
          code: 'CCD',
          description: 'Cancelled',
        }
      }

      post(endpoint, data, null)
        .then((result: any) => {
          if (result.status === 200) {
            notify('success', 'Booking Status Updated')
            setShowCancel(false)
            fetchBooking()
          } else {
            notify('error', result.message)
          }
          setCancelLoading(false)
        })
        .catch(() => {
          setCancelLoading(false)
        })
    } else {
      // Regular status update logic (original code)
      const data: any = {
        status: {
          code: status === 'CCD' ? 'CCD' : status === 'DRF' ? 'DRF' : 'OND',
          description:
            status === 'CCD'
              ? 'Cancelled'
              : status === 'DRF'
              ? 'Shipment Collected'
              : 'Shipment On-hold',
        },
      }
      if (status === 'CCD') {
        data.reason = reason
      }

      let endpoint = `admin/booking/update-status/${id}`
      if (usage === 'floating') {
        endpoint = `admin/update-floating-status/${id}`
      }

      put(endpoint, data)
        .then((result: any) => {
          if (result.status === 200) {
            notify('success', 'Booking Status Updated')
            setShowCancel(false)
            fetchBooking()
          } else {
            notify('error', result.message)
          }
          setCancelLoading(false)
        })
        .catch(() => {
          setCancelLoading(false)
        })
    }
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Update Booking Status</h1>
        <p>
          Note: an email will be sent to the user after this update is done.
        </p>

        <select
          name=''
          id=''
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value=''>-select-</option>
          {statuses.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        {status === 'CCD' && (
          <input
            type='text'
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        )}
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowCancel(false)}>Cancel</button>
            <button className='proceed' onClick={cancelBooking}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default CancelBooking
